export default "__VITE_ASSET__BUtDl$_F__"